import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Box from '@material-ui/core/Box';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import Grid from '@material-ui/core/Grid';
import IconAdd from '@material-ui/icons/Add';
import IconRemove from '@material-ui/icons/Remove';

const useColoredStyles = makeStyles((theme) => ({
  inputContainer: {
    flexGrow: 1,
    backgroundColor: theme.palette.common.white,
  },
  inputBase: {
    height: '100%',
  },
  iconBtn: {
    borderRadius: 0,
    padding: theme.spacing(0.8),
    color: theme.palette.common.white,
  },
  iconPlusBox: {
    backgroundColor: '#54AD7A',
    borderTopRightRadius: theme.typography.pxToRem(2),
    borderBottomRightRadius: theme.typography.pxToRem(2),
  },
  iconMinusBox: {
    borderTopLeftRadius: theme.typography.pxToRem(2),
    borderBottomLeftRadius: theme.typography.pxToRem(2),
    backgroundColor: theme.palette.grey[500],
  },
}));

const useBlackTonedStyles = makeStyles((theme) => ({
  inputContainer: {
    flexGrow: 1,
    backgroundColor: 'transparent',
  },
  inputBase: {
    backgroundColor: 'transparent',
    height: '100%',
  },
  iconBtn: {
    borderRadius: 0,
    padding: theme.spacing(0.2),
    color: 'black',
  },
  iconPlusBox: {
    backgroundColor: theme.palette.common.white,
    borderRadius: 10,
  },
  iconMinusBox: {
    borderRadius: 10,
    backgroundColor: theme.palette.common.white,
  },
}));

const CountTextField = ({
  blackTonedStyle = false,
  defaultValue = 0,
  minValue = 0,
  maxValue = 10000,
  onChange: triggerChangeCallback,
  ...props
}) => {
  const initValue = parseInt(defaultValue, 10);
  const initMinValue = parseInt(minValue, 10);
  const initMaxValue = parseInt(maxValue, 10);
  const blackTonedStyles = useBlackTonedStyles();
  const coloredStyles = useColoredStyles();
  const classes = blackTonedStyle ? blackTonedStyles : coloredStyles;
  const [count, setCount] = React.useState(() => {
    if (initValue < initMinValue) return initMinValue;
    if (initValue > initMaxValue) return initMaxValue;
    return initValue;
  });

  const handlePlusCount = React.useCallback(() => {
    setCount((prev) => {
      if (prev >= initMaxValue) return initMaxValue;
      const newCount = prev + 1;
      triggerChangeCallback(newCount);
      return newCount;
    });
  }, [initMaxValue, triggerChangeCallback]);

  const handleMinusCount = React.useCallback(() => {
    setCount((prev) => {
      if (prev <= initMinValue) return initMinValue;
      const newCount = prev - 1;
      triggerChangeCallback(newCount);
      return newCount;
    });
  }, [initMinValue, triggerChangeCallback]);

  return (
    <Box width={1} height={1}>
      <Grid container wrap="nowrap">
        <Grid item>
          <Box className={classes.iconMinusBox}>
            <IconButton
              className={classes.iconBtn}
              onClick={handleMinusCount}
            >
              <IconRemove />
            </IconButton>
          </Box>
        </Grid>
        <Grid className={classes.inputContainer} item>
          <Box height={1}>
            <InputBase
              className={classes.inputBase}
              fullWidth
              inputProps={{
                style: {
                  backgroundColor: 'transparent',
                  textAlign: 'center',
                },
              }}
              {...props} // eslint-disable-line
              value={count}
            />
          </Box>
        </Grid>
        <Grid item>
          <Box className={classes.iconPlusBox}>
            <IconButton
              className={classes.iconBtn}
              onClick={handlePlusCount}
            >
              <IconAdd />
            </IconButton>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default CountTextField;
